// extracted by mini-css-extract-plugin
export default {"list":"InlineArticleLinks_list__s+hoy"};